import React, { FC } from "react";
import NiceModal, { NiceModalHocProps, useModal } from "@ebay/nice-modal-react";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import "./styles.scss";
import { tt } from "../../../utils/i18n/i18n";

interface Props {
  videoURL: string;
}

const VideoModal: FC<Props & NiceModalHocProps> = NiceModal.create<Props>(
  (props) => {
    const modal = useModal();
    return (
      <KC_Modal_2
        id="video-modal"
        isOpen={modal.visible}
        onClose={modal.hide}
        header={<div className={"w-100 py-2 px-3"}></div>}
      >
        <div className="p-0 p-sm-4 flex-grow-1 h-100 position-relative">
          <iframe
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%"
            }}
            src={`${props.videoURL}?&autoplay=1`}
            title={tt("youtube_video_player")}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </KC_Modal_2>
    );
  }
);

export default VideoModal;
